import type { AppPreferences } from './types';
import type { UpdaterStatus } from '@shared/types';

export const DEFAULT_PREFERENCES: AppPreferences = {
  autoLaunch: false,
  notifications: true,
  quickResponses: {},
};

export const IDLE_UPDATER_STATUS: UpdaterStatus = { state: 'idle' };

